type UniversitySeoData = {
  title: string;
  description: string;
};

/**
 * @description
 * 대학별 SEO 메타데이터를 반환합니다.
 *
 * @param univCode - 대학 코드 (SNU, CAU, KOREA 등)
 * @returns 해당 대학의 SEO 메타데이터
 */
export const getUniversitySeo = (univCode: string): UniversitySeoData => {
  const seoData: Record<string, UniversitySeoData> = {
    SNU: {
      title: 'Seoul National University Off-Campus Housing | Accommodations Near SNU – CheckmateKorea',
      description:
        'Find apartments and rooms near Seoul National University for international students. Affordable and safe off-campus housing listings curated for SNU students.',
    },
    CAU: {
      title: 'Chung-Ang University Off-Campus Housing | Verified Apartments & Studios Near CAU – CheckmateKorea',
      description:
        'Discover rooms and apartments near Chung-Ang University. CheckmateKorea helps international students find safe and affordable housing near CAU.',
    },
    KOREA: {
      title: 'Korea University Off-Campus Housing | Affordable Apartments & Studios Near KU – CheckmateKorea',
      description:
        'Find your perfect apartment near Korea University. Browse safe, affordable off-campus housing options for KU international students.',
    },
    SKKU: {
      title:
        'Sungkyunkwan University Off-Campus Housing | Verified Apartments & Studios for Foreigners – CheckmateKorea',
      description:
        'Find student-friendly apartments and studios near Sungkyunkwan University. Affordable and comfortable housing options curated for foreigners in Seoul.',
    },
    KHU: {
      title: 'Kyung Hee University Off-Campus Housing | Affordable Apartments & Studios – CheckmateKorea',
      description:
        'Looking for affordable off-campus housing near Kyunghee University? CheckmateKorea connects foreigners and expats to safe, verified housing options just minutes from campus with full settlement support.',
    },
    DONGGUK: {
      title: 'Dongguk University Off-Campus Housing | Apartments & Studios for Foreigners – CheckmateKorea',
      description:
        'Find verified apartments and studios near Dongguk University. CheckmateKorea helps foreigners discover affordable housing options within walking distance in Seoul.',
    },
    SSU: {
      title: 'Soongsil University Student Housing | Verified Apartments & Studios for Foreigners – CheckmateKorea',
      description:
        'Browse verified apartments and studios close to Soongsil University. Comfortable housing options ideal for foreign students and expats in Seoul.',
    },
    HUFS: {
      title: 'HUFS Student Off-Campus Housing | Verified Apartments & Studios for Foreigners – CheckmateKorea',
      description:
        'Discover apartments and studios near HUFS. Verified, affordable housing options curated for foreigners seeking comfortable living close to campus in Seoul.',
    },
    EWHA: {
      title: 'Ewha Womans University Apartments | Verified Studios & Housing for Foreigners – CheckmateKorea',
      description:
        'Find verified apartments and studios near Ewha Womans University. Comfortable housing options curated for foreigners wanting to live close to campus in Seoul.',
    },
    KONKUK: {
      title: 'Konkuk University Housing | Verified Apartments & Studios for Foreigners – CheckmateKorea',
      description:
        'Browse apartments and studios near Konkuk University. CheckmateKorea offers foreigners comfortable, verified housing options within minutes of campus in Seoul.',
    },
  };

  return seoData[univCode];
};
